import FalseIcon from '@mui/icons-material/Clear'
import TrueIcon from '@mui/icons-material/Done'
import { Tooltip, Typography } from '@mui/material'
import get from 'lodash/get'
import { useTranslate } from 'ra-core'
import { useRecordContext } from 'react-admin'

const AdvancedBooleanField = ({
  className,
  color,
  falseIcon = FalseIcon,
  falseLabel = 'ra.boolean.false',
  falseTooltip = '',
  overrideLabel,
  source,
  sx,
  tooltip: defaultTooltip = '',
  trueIcon = TrueIcon,
  trueLabel = 'ra.boolean.true',
  trueTooltip = '',
  ...props
}) => {
  const record = useRecordContext(props)
  const translate = useTranslate()
  const isTrue = Boolean(get(record, source))
  const tooltip = (isTrue ? trueTooltip : falseTooltip) || defaultTooltip
  const Icon = isTrue ? trueIcon : falseIcon
  const label = overrideLabel || (isTrue ? trueLabel : falseLabel)

  return (
    <Typography component="span" variant="body2" className={className} color={color} sx={sx}>
      <Tooltip title={translate(tooltip)}>
        <span>
          {Icon && <Icon sx={{ verticalAlign: 'bottom', mr: '0.25em' }} />}
          {translate(label)}
        </span>
      </Tooltip>
    </Typography>
  )
}

export default AdvancedBooleanField
